'use strict';
var HiddenState;
(function (HiddenState) {
    HiddenState["None"] = "none";
    HiddenState["All"] = "all";
    HiddenState["Mobile"] = "mobile";
    HiddenState["Desktop"] = "desktop";
})(HiddenState || (HiddenState = {}));
export default HiddenState;
